import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FloatingAction from '../floating-action';
import Text from '../text';
import noop from '../utils/noop';
import isNoop from '../utils/is-noop';

const HALF_BUTTON_SIZE = 24;

function AddContentTrigger({
  captions: { title, annotation },
  icon = 'plus',
  onClick = noop,
  centered = false,
  onContextMenu = noop,
}) {
  const classes = classNames('ws-add-content-trigger', {
    'ws-add-content-trigger--centered': centered,
  });

  const contextMenuHandler = (event) => {
    if (isNoop(onContextMenu)) return;
    event.preventDefault();
    const { clientX, clientY } = event;
    onContextMenu(clientX, clientY);
  };

  return (
    <div className="ws-add-content-trigger-wrapper" onContextMenu={contextMenuHandler}>
      <div className={classes}>
        <Text type="heading-5">{title}</Text>
        <div className="ws-add-content-trigger__button">
          <FloatingAction
            icon={icon}
            onClick={onClick}
            offsetX={HALF_BUTTON_SIZE}
            offsetY={HALF_BUTTON_SIZE}
          />
        </div>
        <Text type="heading-6" theme="grey">
          {annotation}
        </Text>
      </div>
    </div>
  );
}

AddContentTrigger.propTypes = {
  icon: PropTypes.string,
  onClick: PropTypes.func,
  onContextMenu: PropTypes.func,
  centered: PropTypes.bool,
  captions: PropTypes.shape({
    title: PropTypes.string,
    annotation: PropTypes.string,
  }).isRequired,
};

export default AddContentTrigger;
